// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
const deferDispatch = require('client-v2/common/state/dispatch')
// Sibling imports
const SMSModal = require('./component-dumb')
const smsModalActions = require('./actions')

function mapStateToProps(state, ownProps) {
  const { env, smsModal } = state
  const headingSelector = createSelector(
    state => state.smsModal,
    smsModal => {
      if (smsModal.isSubmitFailed) {
        return 'Sorry, we could not send the SMS.'
      }
      if (smsModal.isSubmitSuccessful) {
        return 'SMS sent.'
      }
      return 'Get the Mix App'
    }
  )
  const subheadingSelector = createSelector(
    state => state.smsModal,
    smsModal => {
      if (smsModal.isDownloadPromptVisible) {
        return 'Select your device type to download the app and start Mixing!'
      }
      if (smsModal.isSubmitFailed) {
        return 'Please contact support@mix.com.'
      }
      if (smsModal.isSubmitSuccessful) {
        return 'Go check your phone!'
      }
      return 'Enter your phone number so we can send you a link to download Mix'
    }
  )
  if (!smsModal){
    return { isVisible: false }
  }
  return {
    // Flags
    isSubmitFailed: smsModal.isSubmitFailed,
    isSubmitSuccessful: smsModal.isSubmitSuccessful,
    isVisible: true,
    isDownloadPromptVisible: smsModal.isDownloadPromptVisible,
    // Values
    assets: env.assets,
    deeplinkData: smsModal.deeplinkData,
    heading: headingSelector(state),
    subheading: subheadingSelector(state),
    qrCode: env.deeplinkUrls.get('qrCode'),
    ...ownProps
  }
}

function mapDispatchToProps(dispatch, props) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onDismiss: props.onDismiss || dispatchAction(smsModalActions.hide),
    onSendSMS: dispatchAction(smsModalActions.sendDownloadLink),
    onDownloadClick: dispatchAction(smsModalActions.showDownloadSelected),
    onSubmitError: dispatchAction(smsModalActions.showSubmitError),
    onSubmitSuccess: dispatchAction(smsModalActions.showSubmitSuccess)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      SMSModal
    )
  )
)
